import '@babel/polyfill'
import './mock'
import './style.scss'
import Vue from 'vue'
import axios from 'common/js/axios'
import Share from 'common/js/share'
import receiveCoupon from '../components/receive-coupon'
import { Toast, Popup, Picker, Icon, CellGroup, Field, Swipe, SwipeItem, Checkbox, Dialog } from 'vant'
import 'vant/lib/icon/local.css'
import storejs from 'store'
import dayjs from 'dayjs'
import fundebug from 'fundebug-javascript'
import fundebugVue from 'fundebug-vue'
const { vars, shareData } = require('./config')

if (process.env.VUE_APP_ENV === 'prod') {
  fundebug.apikey = '7c3f418b6319a3c8a15ebf8b209305e3993ea5e0b3c402e37758edc233434696'
  fundebug.filters = [
    {
      type: /^unhandledrejection$/
    }
  ]
  fundebug.silentResource = true
  fundebugVue(fundebug, Vue)
}

Vue.config.productionTip = false

Vue.use(vars)
Vue.use(axios,{
  ends:true
})
// eslint-disable-next-line
new Share(shareData)
Vue.use(receiveCoupon)
Vue.use(Toast)
Vue.prototype.$loading = () => {
  return Toast.loading({
    message: 'Loading...',
    duration: 0,
    forbidClick: true
  })
}
Vue.prototype.$loading.clear = () => {
  return Toast.clear()
}
Vue.use(Popup)
Vue.use(Picker)
Vue.use(Icon)
Vue.use(CellGroup)
Vue.use(Field)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Checkbox)
Vue.use(Dialog)

Vue.prototype.$storejs = storejs
Vue.prototype.$dayjs = dayjs

if (process.env.VUE_APP_ENV !== 'prod') {
  const VConsole = require('vconsole')
  // eslint-disable-next-line
  new VConsole()
} else {
  const AlloyLever = require('alloylever')
  AlloyLever.config({
    cdn: 'https://a-img.pangku.com/common/181104/vconsole.min.js'
  })
}
